import { IconCirclePlusOutline18 as PlusCircleIcon } from "nucleo-ui-outline-18"

import type { SlashCommandDefinition } from "../types"
import { iconClassName } from "../constants"

export const tableAddColumnCommand: SlashCommandDefinition = {
	key: "table-add-column",
	title: "Add Column to Table",
	icon: <PlusCircleIcon strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor.chain().focus().deleteRange(range).addColumnAfter().run()
	},
	group: "table",
}
